import { render, staticRenderFns } from "./Info_mobile_basico.vue?vue&type=template&id=1dae2f4f&scoped=true&"
import script from "./Info_mobile_basico.vue?vue&type=script&lang=js&"
export * from "./Info_mobile_basico.vue?vue&type=script&lang=js&"
import style0 from "./Info_mobile_basico.vue?vue&type=style&index=0&id=1dae2f4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae2f4f",
  null
  
)

export default component.exports